<div class="overflow-auto h-full si-table-container" [formGroup]="form">
    <table class="si-table" [formArrayName]="mappingType">
        <thead>
            <tr>
                <th width="30%" scope="col" class="border-t-0 sticky top-0 uppercase text-primary">SalesIntel FIELD</th>
                <th width="40%" scope="col" class="border-t-0 sticky top-0 uppercase text-primary">{{exportType}} FIELD</th>
                <th width="30%" scope="col" class="text-center border-t-0 sticky top-0 uppercase text-primary">Use Full Name</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let field of mappings; let first = first; let i = index" [formGroupName]="i">
                <tr class="menu-item line-li"
                    *ngIf="!first && mappings[i-1] && mappings[i-1].groupId !== field.groupId">
                    <td colspan="3" class="group-mapping">&nbsp;</td>
                </tr>
                <tr>
                    <td class="capitalize align-middle" scope="row">
                        {{field.salesintelField | salesintelPrettyField}}</td>
                    <td *ngIf="mappingType == 'prospectMapping'" class="capitalize align-middle" scope="row">
                        {{ field.outreachField}}</td>
                    <td  *ngIf="mappingType == 'peopleMapping'" class="capitalize align-middle" scope="row">
                        {{ field.salesloftField}}</td>
                    <td class="text-center align-middle">
                        <span [hidden]="field.useFullName === null">
                            <mat-slide-toggle
                                formControlName="useFullName"
                            ></mat-slide-toggle>
                        </span>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
